import { AuthKitStateInterface } from '../types';
import {
  ActionType,
  AuthActions,
  SignInAction,
  SignInActionPayload,
  SignOutAction,
  RefreshTokenAction,
  RefreshTokenActionPayload,
} from './actions';

export function authReducer(
  state: AuthKitStateInterface,
  action: AuthActions
): AuthKitStateInterface {
  switch (action.type) {
    case ActionType.SignIn:
      return {
        ...state,
        auth: action.payload.auth,
        refresh: action.payload.refresh,
        userState: action.payload.userState,
        isSignIn: true,
      };
    case ActionType.SignOut:
      return {
        ...state,
        auth: null,
        refresh: null,
        userState: null,
        isSignIn: false,
      };
    case ActionType.RefreshToken:
      if (state.isSignIn && state.auth && state.refresh) {
        return {
          ...state,
          auth: {
            token: action.payload.newAuthToken
              ? action.payload.newAuthToken
              : state.auth.token,
            type: state.auth.type,
            expiresAt: action.payload.newAuthTokenExpireIn
              ? new Date(
                  new Date().getTime() +
                    action.payload.newAuthTokenExpireIn * 60 * 1000
                )
              : state.auth.expiresAt,
          },
          refresh: {
            token: action.payload.newRefreshToken
              ? action.payload.newRefreshToken
              : state.refresh.token,
            expiresAt: action.payload.newRefreshTokenExpiresIn
              ? new Date(
                  new Date().getTime() +
                    action.payload.newRefreshTokenExpiresIn * 60 * 1000
                )
              : state.refresh.expiresAt,
          },
          userState: action.payload.newAuthUserState
            ? action.payload.newAuthUserState
            : state.userState,
        };
      } else {
        return state;
      }
  }
}

export function doSignIn(signInParams: SignInActionPayload): SignInAction {
  return {
    type: ActionType.SignIn,
    payload: signInParams,
  };
}

export function doRefresh(
  refreshTokenParam: RefreshTokenActionPayload
): RefreshTokenAction {
  return {
    type: ActionType.RefreshToken,
    payload: refreshTokenParam,
  };
}

export function doSignOut(): SignOutAction {
  return {
    type: ActionType.SignOut,
  };
}
